// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0d282add","132":"24a752ba","196":"208a33c2"}[chunkId] + ".chunk.js";
};